module.exports = __webpack_public_path__ + "static/media/icon-wp-admin.17a00a27.svg";